import CalculatorPage from 'components/redesign/CalculatorPage';
import MobileDevelopmentPage from 'components/redesign/MobileDevelopmentPage';
import { Navigate, useParams, useRoutes } from 'react-router-dom';
import AboutRedesignPage from 'components/redesign/AboutRedesignPage';
import AllServicesPage from 'components/redesign/AllServicesPage';
import BlogRedesignPage from 'components/redesign/BlogRedesignPage';
import HomePage from 'components/redesign/HomePage';
import PlaceholderPage from 'components/redesign/PlaceholderPage';
import ContactsRedesignPage from 'components/redesign/ContactsRedesignPage';
import CorporateWebsitesPage from 'components/redesign/CorporateWebsitesPage';
import DigitalTrends2026ArticlePage from 'components/redesign/DigitalTrends2026ArticlePage';
import EcommerceDevelopmentPage from 'components/redesign/EcommerceDevelopmentPage';
import FitnessCourseLandingCasePage from 'components/redesign/FitnessCourseLandingCasePage';
import LandingDevelopmentPage from 'components/redesign/LandingDevelopmentPage';
import MobileRoiArticlePage from 'components/redesign/MobileRoiArticlePage';
import PortfolioRedesignPage from 'components/redesign/PortfolioRedesignPage';
import RedesignSupportPage from 'components/redesign/RedesignSupportPage';
import RequisitesPage from 'components/redesign/RequisitesPage';
import RknCheckPage from 'components/redesign/RknCheckPage';
import SeoWebsiteDevelopmentPage from 'components/redesign/SeoWebsiteDevelopmentPage';
import SeoTop3ArticlePage from 'components/redesign/SeoTop3ArticlePage';
import ServiceBusinessPage from 'components/redesign/ServiceBusinessPage';
import SitemapPage from 'components/redesign/SitemapPage';
import SokolnikiRestaurantCasePage from 'components/redesign/SokolnikiRestaurantCasePage';
import TechStoreCasePage from 'components/redesign/TechStoreCasePage';
import VacanciesRedesignPage from 'components/redesign/VacanciesRedesignPage';
import WebsiteDevelopmentPage from 'components/redesign/WebsiteDevelopmentPage';
import WebsitesCategoryPage from 'components/redesign/WebsitesCategoryPage';
import YandexMapsPage from 'components/redesign/YandexMapsPage';
import FeedbackPage from 'components/feedbackPage/FeedbackPage';
import Project from 'components/project/Project';
import ServicePage from 'components/servicePage/ServicePage';
import Article from 'components/articlePage/Article';

function NumericRoute({ children }) {
  const { id } = useParams();

  // TODO(brand-redesign): replace slug placeholder routes with real redesigned pages.
  if (!/^\d+$/.test(String(id))) {
    return <PlaceholderPage />;
  }

  return children;
}

export default function ThemeRoutes() {
  return useRoutes([MainRoutes]);
}

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <HomePage />,
    },
    {
      path: 'services',
      element: <Navigate to="/services/vseuslugi/" replace />,
    },
    {
      path: 'services/vseuslugi',
      element: <AllServicesPage />,
    },
    {
      path: 'services/seo',
      element: <SeoWebsiteDevelopmentPage />,
    },
    {
      path: 'services/seo/full-cycle',
      element: <SeoWebsiteDevelopmentPage />,
    },
    {
      path: 'services/yandex-maps',
      element: <YandexMapsPage />,
    },
    {
      path: 'services/websites',
      element: <WebsitesCategoryPage />,
    },
    {
      path: 'services/websites/full-cycle',
      element: <WebsiteDevelopmentPage />,
    },
    {
      path: 'services/websites/corporate',
      element: <CorporateWebsitesPage />,
    },
    {
      path: 'services/websites/landing',
      element: <LandingDevelopmentPage />,
    },
    {
      path: 'services/websites/ecommerce',
      element: <EcommerceDevelopmentPage />,
    },
    {
      path: 'services/websites/seo',
      element: <SeoWebsiteDevelopmentPage />,
    },
    {
      path: 'services/websites/redesign-support',
      element: <RedesignSupportPage />,
    },
    {
      path: 'services/websites/service-business',
      element: <ServiceBusinessPage />,
    },
    {
      path: 'services/websites/rkn-check',
      element: <RknCheckPage />,
    },
    { path: 'services/mobile', element: <MobileDevelopmentPage pageKey="mobile" /> },
    { path: 'services/mobile/mvp', element: <MobileDevelopmentPage pageKey="mvp" /> },
    { path: 'services/mobile/ios', element: <MobileDevelopmentPage pageKey="ios" /> },
    { path: 'services/mobile/aso', element: <MobileDevelopmentPage pageKey="aso" /> },
    { path: 'services/mobile/publishing/rustore', element: <MobileDevelopmentPage pageKey="rustore" /> },
    { path: 'services/mobile/publishing/app-store', element: <MobileDevelopmentPage pageKey="app-store" /> },
    { path: 'services/mobile/publishing/google-play', element: <MobileDevelopmentPage pageKey="google-play" /> },
    { path: 'services/mobile/publishing', element: <MobileDevelopmentPage pageKey="publishing" /> },
    { path: 'services/mobile/integrations', element: <MobileDevelopmentPage pageKey="integrations" /> },
    { path: 'services/mobile/android', element: <MobileDevelopmentPage pageKey="android" /> },
    {
      path: 'calculator',
      element: <CalculatorPage />,
    },
    {
      path: 'about',
      element: <AboutRedesignPage />,
    },
    {
      path: 'vacancies',
      element: <VacanciesRedesignPage />,
    },
    {
      path: 'requisites',
      element: <RequisitesPage />,
    },
    {
      path: 'contacts',
      element: <ContactsRedesignPage />,
    },
    {
      path: 'privacy',
      element: <PlaceholderPage />,
    },
    {
      path: 'offer',
      element: <PlaceholderPage />,
    },
    {
      path: 'cookies',
      element: <PlaceholderPage />,
    },
    {
      path: 'sitemap',
      element: <SitemapPage />,
    },
    {
      path: 'feedback',
      element: <FeedbackPage />,
    },
    {
      path: 'blog',
      children: [
        {
          path: 'digital-trends-2024',
          element: <DigitalTrends2026ArticlePage />,
        },
        {
          path: 'digital-trends-2026',
          element: <Navigate replace to="/blog/digital-trends-2024/" />,
        },
        {
          path: 'mobile-roi',
          element: <MobileRoiArticlePage />,
        },
        {
          path: 'seo-top3',
          element: <SeoTop3ArticlePage />,
        },
        {
          path: ':id',
          element: (
            <NumericRoute>
              <Article />
            </NumericRoute>
          ),
        },
        {
          path: '',
          element: <BlogRedesignPage />,
        },
      ],
    },
    {
      path: 'portfolio',
      children: [
        {
          path: 'tech-store',
          element: <TechStoreCasePage />,
        },
        {
          path: 'sokolniki-restaurant',
          element: <SokolnikiRestaurantCasePage />,
        },
        {
          path: 'fitness-course-landing',
          element: <FitnessCourseLandingCasePage />,
        },
        {
          path: ':id',
          element: (
            <NumericRoute>
              <Project />
            </NumericRoute>
          ),
        },
        {
          path: '',
          element: <PortfolioRedesignPage />,
        },
      ],
    },
    {
      path: 'services/:id',
      element: (
        <NumericRoute>
          <ServicePage />
        </NumericRoute>
      ),
    },
    {
      path: '*',
      element: <PlaceholderPage />,
    },
  ],
};
